import React from 'react';
import { Flex, Text, Button } from '@chakra-ui/react';

export default function ErrorState({ message = 'Something went wrong.', onRetry, minH = '40vh' }) {
  return (
    <Flex align="center" justify="center" minH={minH} direction="column" gap={3} bg="gray.50" color="red.600">
      <Text fontSize="lg" fontWeight="bold">{message}</Text>
      {onRetry ? (
        <Button colorScheme="red" variant="outline" onClick={onRetry}>Retry</Button>
      ) : null}
    </Flex>
  );
}


